// extracted by mini-css-extract-plugin
export default {"mainContainer":"News_mainContainer__s6VBz","imageContainer":"News_imageContainer__bhs1T","content":"News_content__VLEk+"};